import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { CheckCircle } from "lucide-react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const ModificationValidated = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="container mx-auto px-4 py-16">
        <div className="max-w-2xl mx-auto text-center">
          <Card className="p-8 shadow-warm">
            <div className="flex flex-col items-center space-y-6">
              <CheckCircle className="w-16 h-16 text-green-500" />
              
              <h1 className="text-3xl font-serif font-semibold text-foreground">
                Vos modifications ont été validées
              </h1>
              
              <p className="text-xl text-muted-foreground">
                Merci, vos changements ont bien été pris en compte !
              </p>
              
              <div className="pt-6">
                <Button asChild size="lg">
                  <Link to="/">
                    Retour à l'accueil
                  </Link>
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ModificationValidated;